import { render, staticRenderFns } from "./VideoObserver.vue?vue&type=template&id=5605dc4f&"
import script from "./VideoObserver.vue?vue&type=script&lang=js&"
export * from "./VideoObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports